
import AppColumnSelect from "@/components/models/ColumnSelect.vue";
import Vue from "vue";
import { Model } from "../../../utils/models/model";

export default Vue.extend({
	data() {
		return {
			selectedColumn: ""
		};
	},
	props: {
		model: Object as () => Model,
		selectedColumns: {
			type: Array as () => string[],
			required: true
		}
	},
	computed: {
		ignoredFields():string[] {
			let result = [...this.selectedColumns];
			let namedFilters = this.model.getAvailableNamedFilters().filter(f=>!f.canBeUsedAsDefaultViewFilter);
			result.push(...namedFilters.map(f=>f.name));
			return result;
		}
	},
	methods: {
		add() {
			this.selectedColumns.push(this.selectedColumn);
			this.$emit("save");
			this.close();
		},
		close() {
			this.$emit("close");
		}
	},
	components: {
		AppColumnSelect
	},
	i18nEx: {
		componentPrefix: "components.settings-browse"
	}
});
